import React from 'react'
import { Button, Text } from 'grommet'
import { useTranslation } from 'react-i18next'

import { trackEvent } from 'utils/useGTM'
import useDeviceSize from 'hooks/useDevice'
import { useProvider } from 'hooks/useMoodPlot'

export default function BrowseEmotionsButton() {
  const { t } = useTranslation()
  const { small } = useDeviceSize()
  const { resetAngle } = useProvider()
  return (
    <Button
      primary
      color="brand"
      size={small ? 'large' : 'small'}
      onClick={() => {
        trackEvent({ event: 'BrowseEmotionsButton' })
        resetAngle()
      }}
      label={
        <Text color="white" size={small ? 'large' : 'small'}>
          {t('cta.browse-emotions')}
        </Text>
      }
    />
  )
}
